module.exports = __webpack_public_path__ + "4e992b1cef5c178f11800291ad7d4f92.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-76@2x.png
// module id = 536
// module chunks = 0